import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface ImagePreviewModalData {
  url: string;
  name: string;
}

@Component({
  selector: 'app-image-preview-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './image-preview-modal.component.html',
  styleUrl: './image-preview-modal.component.scss'
})
export class ImagePreviewModalComponent {
  isImageLoaded = false;
  hasError = false;

  constructor(
    private readonly dialogRef: MatDialogRef<ImagePreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImagePreviewModalData
  ) {}

  onImageLoad(): void {
    this.isImageLoaded = true;
  }

  onImageError(): void {
    this.hasError = true;
    this.isImageLoaded = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
